import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, X } from 'lucide-react';
import './FloatingAppointment.css';

function FloatingAppointment() {
  const [isVisible, setIsVisible] = useState(true);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling 300px
      if (window.scrollY >= 0) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleDismiss = (e) => {
    e.preventDefault();
    setIsDismissed(true);
  };

  if (isDismissed) return null;

  return (
    <div className={`floating-appointment ${isVisible ? 'visible' : ''}`}>
      <button className="floating-dismiss" onClick={handleDismiss} aria-label="Dismiss">
        <X size={16} />
      </button>
      <Link to="/appointment-request" className="floating-btn">
        <div className="floating-icon">
          <Calendar size={24} />
        </div>
        <div className="floating-text">
          <span className="floating-label">Schedule Now</span>
          <span className="floating-subtitle">Quick & Easy</span>
        </div>
      </Link>
    </div>
  );
}

export default FloatingAppointment;
